import React, { useCallback, useEffect, useState } from "react";
import i18next from "i18next";
import DataTable from "../../../../components/dataTable/DataTable";
import _, { set } from "lodash";
import { Box } from "@mui/material";
import CustomPagination from "../../../../components/pagination/CustomPagination";
import styles from "./groupTableComponent.module.scss";
import CustomSnackbar from "../../../../components/customSnackBar/CustomSnackbar";
import PropTypes from "prop-types";
import ActionComponent from "../actionComponent/ActionComponent";
import CustomModalDialog from "../../../../components/modal/CustomModalDialog";
import DeleteDealer from "../deleteDealerContent/DeleteDealer";
import { deleteGroup } from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import { setIn } from "formik";

const GroupTableComponent = (props) => {
  const {
    groupList,
    snackBarMessage,
    openSnackbar,
    setOpenSnackbar,
    onSortChange,
    sortModel = [],
    pageSize,
    pageNumber,
    totalRecords,
    handlePageChange,
    handlePageSizeChange,
    setEditGroupDrawerState,
    setGroupDetails,
    setGroupListTable,
    setInGroupTable,
    setSelectedGroup,
    setSelectedGroupId,
    refreshTable,
  } = props;

  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [isShowModalFlag, setIsShowModalFlag] = useState(false);
  const [deleteGroupId, setDeleteGroupId] = useState(null);
  const { setApiErrorModalState } = useApiErrorModalContext();

  const handleEditGroup = useCallback(
    (groupDetails) => {
      setGroupDetails(groupDetails);
      setEditGroupDrawerState(true);
    },
    [setEditGroupDrawerState, setGroupDetails]
  );

  const handleDeleteBtnClick = (id) => {
    setDeleteGroupId(id);
    setIsShowModalFlag(true);
  };

  useEffect(() => {
    const tableHeaderColumns = [
      {
        field: "dealergroup_Id",
        headerName: i18next.t("ID"),
        flex: 1.5,
        sortable: !_.isEmpty(groupList),
        renderCell: (params) => (
          <Box className={styles.textStyle1}>{params.row?.dealergroup_Id}</Box>
        ),
      },
      {
        field: "group_Name",
        headerName: i18next.t("Group"),
        flex: 2.0,
        sortable: !_.isEmpty(groupList),
        renderCell: (params) => (
          <Box
            className={styles.groupName}
            onClick={() => {
              setGroupListTable(true);
              setSelectedGroupId(params.row?.dealergroup_Id);
              setSelectedGroup(params.row);
              setInGroupTable(true);
            }}
          >
            {params.row?.group_Name}
          </Box>
        ),
      },
      {
        field: "group_email_id",
        headerName: i18next.t("Contact"),
        flex: 2.5,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.contactWrapper}>
            <Box className={styles.iconTextStyle}>
              {!_.isEmpty(_.get(params, "row.group_email_id", "")) ? (
                <>
                  <span className={styles.mailIcon}></span>
                  <span className={styles.textIcon}>
                    {_.get(params, "row.group_email_id")}
                  </span>
                </>
              ) : (
                "-"
              )}
            </Box>
          </Box>
        ),
      },
      {
        field: "group_City",
        headerName: i18next.t("City(headquarters)"),
        flex: 2.0,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.textStyle2}>
            {!_.isEmpty(_.get(params, "row.group_City", ""))
              ? params.row?.group_City
              : "-"}
          </Box>
        ),
      },
      {
        field: "noofDealers",
        headerName: i18next.t("No. of dealers"),
        flex: 1.0,
        sortable: false,
        renderCell: (params) => (
          <Box className={styles.textColorStyle}>{params.row?.noofDealers}</Box>
        ),
      },
      {
        flex: 0.8,
        sortable: false,
        renderCell: (params) => (
          <Box
            className={styles.editTextStyle}
            onClick={() => handleEditGroup(params.row)}
          >
            {i18next.t("Edit")}
          </Box>
        ),
      },
      {
        field: "activ",
        headerName: i18next.t("Actie"),
        flex: 0.4,
        sortable: false,
        renderCell: (params) => (
          <ActionComponent
            title={params.row?.status}
            hasIcon={false}
            dealerDetails={params.row}
            showPopover={true}
            handleDeleteClick={() => {
              handleDeleteBtnClick(params.row?.dealergroup_Id);
            }}
            content={
              <Box className={styles.inActiveStatusStyle}>
                <span className={styles.dotIcon}></span>
              </Box>
            }
          />
        ),
      },
    ];
    setTableHeader(tableHeaderColumns);
    setTableColumnData(groupList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupList, handleEditGroup, setGroupListTable, setSelectedGroup]);

  const handleDealerDelete = () => {
    deleteGroup({ dealergrpId: deleteGroupId })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDeleteGroupId(null);
          refreshTable();
          setIsShowModalFlag(false);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };


  return (
    <Box data-testid="GroupTableComponent">
      <DataTable
        columns={tableHeader}
        rows={tableColumnData}
        isShowMessage={true}
        isShowTableWhenNoResult={true}
        disableColumnMenu={true}
        disableColumnFilter={true}
        hideFooter={true}
        isCheckboxSelection={false}
        disableRowSelectionOnClick={true}
        onSortModelChange={(model) => onSortChange(model)}
        sortModel={sortModel}
        refreshTable={refreshTable}
      />
      <CustomSnackbar
        open={openSnackbar}
        message={snackBarMessage}
        setOpen={setOpenSnackbar}
      />

      {isShowModalFlag ? (
        <CustomModalDialog
          title={"Remove selected group"}
          isShow={isShowModalFlag}
          onClose={() => setIsShowModalFlag(false)}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
        >
          <DeleteDealer
            handleDelete={handleDealerDelete}
            handleCancel={() => setIsShowModalFlag(false)}
            primaryMessage ={i18next.t("Are you sure you want to delete the selected group?")}
            secondaryMessage= {i18next.t("You cannot retrieve it back")}
          />
        </CustomModalDialog>
      ) : (
        ""
      )}

      {!_.isEmpty(groupList) && pageSize < totalRecords ? (
        <CustomPagination
          row={tableColumnData}
          paginationResult={{
            pageSize: pageSize,
            pageNumber: pageNumber,
            totalRecords: totalRecords,
          }}
          setCurrentPageNumber={handlePageChange}
          showRowPerPage={false}
          setCurrentPageSize={handlePageSizeChange}
        />
      ) : null}
    </Box>
  );
};

export default GroupTableComponent;

GroupTableComponent.propTypes = {
  groupList: PropTypes.any,
  snackBarMessage: PropTypes.any,
  openSnackbar: PropTypes.any,
  setOpenSnackbar: PropTypes.any,
  onSortChange: PropTypes.any,
  sortModel: PropTypes.any,
  pageSize: PropTypes.any,
  pageNumber: PropTypes.any,
  totalRecords: PropTypes.any,
  handlePageChange: PropTypes.any,
  handlePageSizeChange: PropTypes.any,
  setEditGroupDrawerState: PropTypes.any,
  setGroupDetails: PropTypes.any,
  setGroupListTable: PropTypes.any,
  setSelectedGroup: PropTypes.any,
  setSelectedGroupId: PropTypes.any,
  setInGroupTable: PropTypes.any,
  refreshTable: PropTypes.any,
};
